import { Subject } from 'rxjs/Subject';
var DashboardPageInboxCountUpdateService = /** @class */ (function () {
    function DashboardPageInboxCountUpdateService() {
        // Observable string sources
        this.inobxCountUpdateSource = new Subject();
        // Observable string streams
        this.inobxCount$ = this.inobxCountUpdateSource.asObservable();
    }
    // Service message commands
    DashboardPageInboxCountUpdateService.prototype.updateInboxCount = function (inboxCountData) {
        this.inobxCountUpdateSource.next(inboxCountData);
    };
    return DashboardPageInboxCountUpdateService;
}());
export { DashboardPageInboxCountUpdateService };
//# sourceMappingURL=dashboardPageInboxCountUpdateService.service.js.map